import { render, staticRenderFns } from "./accessContents.vue?vue&type=template&id=33994f4c&scoped=true&"
import script from "./accessContents.vue?vue&type=script&lang=js&"
export * from "./accessContents.vue?vue&type=script&lang=js&"
import style0 from "./accessContents.vue?vue&type=style&index=0&id=33994f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33994f4c",
  null
  
)

component.options.__file = "accessContents.vue"
export default component.exports